/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const taxVerificationStatus = {
	pending: 'pending',
	unavailable: 'unavailable',
	unverified: 'unverified',
	verified: 'verified',
} as const

export type TaxVerificationStatus = (typeof taxVerificationStatus)[keyof typeof taxVerificationStatus]
